import { render, staticRenderFns } from "./PromotionForm.vue?vue&type=template&id=3f1e247c&scoped=true&"
import script from "./PromotionForm.vue?vue&type=script&lang=js&"
export * from "./PromotionForm.vue?vue&type=script&lang=js&"
import style0 from "./PromotionForm.vue?vue&type=style&index=0&id=3f1e247c&prod&scoped=true&lang=css&"
import style1 from "./PromotionForm.vue?vue&type=style&index=1&id=3f1e247c&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f1e247c",
  null
  
)

export default component.exports